<template>
  <div id="orderHistory">
      <div class="horn">进入后台输入激活码即可使用</div>
      <div class="box" v-if="unpayList.length">
        <div class="title">
          待支付订单
        </div>
        <div class="unpay" v-for="m in unpayList" :key="m.id">
          <div class="unpay_title">
            <div class="mealName">{{m.setMelName}}</div>
            <div class="countdown">
              <!-- 下单时间：{{m.firstUpdateTime}}
              当前时区：{{timezone2}} -->
              剩余支付时间 
              <span class="time" v-if="m.countTimeDesc">{{m.countTimeDesc}}</span>
              <span class="time" v-else style="color:#ccc">已过期</span>
            </div>
          </div>
          <div class="unpay_body">
            <div class="body_row">
              <div class="body_col w100">
                【订单编号】：{{m.orderCode}}
              </div>
              <div class="body_col w100">
                【创建时间】：{{m.firstUpdateTime}}
              </div>
              <div class="body_col">
                【服务器支持人数】：{{m.attributeData.serverPeopleNum}}人
              </div>
              <div class="body_col">
                【圈子数量上限】：{{m.attributeData.circleNum}}个
              </div>
              <div class="body_col">
                【管理员数量上限】：{{m.attributeData.adminNum}}人
              </div>
              <div class="body_col">
                【是否支持Kurento】：{{m.attributeData.isKurento ? '支持' : '不支持'}}
              </div>
              <!-- <div class="body_col w100 module">
                【团队】：
                <span class="aModule">测试1</span>
                <span class="aModule">测试2</span>
                <span class="aModule">测试3</span>
                <span class="aModule">测试4</span>
              </div> -->
              <div class="body_col w100 module" v-for="_m in modules" :key="_m.id">
                【{{_m.moduleName}}】：
                <template v-for="_mm in _m.appFunctionList">
                  <span class="aModule" :key="_mm.id" v-if="_mm.funType == 1 || m.funCodeArr.includes(_mm.functionCode)">
                      {{_mm.name}}</span>
                </template>
              </div>
            </div>
            <div class="unpan_footer"> 
                <div class="priceBox">
                  待支付：<span class="price">${{(m.payment || 0).toFixed(2)}}</span>
                </div>
                <span class="cancel" @click="cancelOrder(m,$event)">取消订单</span>
                <el-button type="primary" @click="readyPay(m,$event)" :disabled="!m.countTimeDesc">立即支付</el-button>
            </div>
          </div>
        </div>
      </div>

      <div class="box">
        <div class="title">已购买订单</div>
        <div class="list">
          <el-table
            :data="list"
            tooltip-effect="dark"
          >
              <el-table-column prop="paymentTime" label="购买时间"></el-table-column>
              <el-table-column prop="setMelName" label="购买套餐"></el-table-column>
              <el-table-column label="支付金额">
                  <template slot-scope="scope">
                      $<span>{{scope.row.payment}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop="activationTime" label="激活时间"></el-table-column>
              <el-table-column prop="expireTime" label="到期时间"></el-table-column>
              <el-table-column label="订单状态">
                  <template slot-scope="scope">
                    <span style="color:green" v-if="scope.row.orderStatus == 6">已完成</span>
                    <!-- <span style="color:red" v-if="scope.row.orderStatus == 1">待支付</span> -->
                    <span style="color:#ccc" v-if="scope.row.orderStatus == 5">已关闭</span>
                    <span style="color:red" v-if="scope.row.orderStatus == 2">待激活</span>
                  </template>
              </el-table-column>
              <el-table-column label="注册码">
                  <template slot-scope="scope">
                      <el-link v-if="scope.row.orderStatus != 2 && scope.row.machineCode" @click="viewMachineCode(scope.row)">查看</el-link>
                  </template>
              </el-table-column>
              <el-table-column label="激活码">
                  <template slot-scope="scope">
                      <el-link v-if="scope.row.orderStatus == 2" style="color:red;" @click="createdCDKEY(scope.row,$event)">生成</el-link> 
                      <el-link v-else-if="scope.row.activationCode" @click="viewActivationCode(scope.row)">查看</el-link>
                  </template>
              </el-table-column>
              <el-table-column label="操作">
                  <template slot-scope="scope">
                      <el-link @click="viewOrder(scope.row)">查看</el-link>
                  </template>
              </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- <div class="list">
        <div class="order" v-for="m in list" :key="m.id" @click="viewOrder(m)">
            <div>{{m.setMelName}}</div>
            <div>{{m.introduce}}</div>
            <div v-if="m.orderStatus == 6">支付金额：${{m.payment}}</div>
            <div v-if="m.orderStatus != 6">待支付金额：${{m.payment}}</div>
            <div v-if="m.machineCode" style="word-break: break-all;">机器码：{{m.machineCode}}</div>
            <div v-if="m.activationCode" style="word-break: break-all;width:200px;">激活码：<b>{{m.activationCode}}</b></div>
            <div v-if="m.orderStatus == 1"><button @click="cancelOrder(m,$event)">取消订单</button></div>
            <div v-if="m.orderStatus == 1"><button @click="readyPay(m,$event)">立即支付</button></div>
            <div v-if="m.orderStatus == 6">订单状态 <span style="color:green">已完成</span> </div>
            <div v-if="m.orderStatus == 1">订单状态 <span style="color:red">待支付</span> </div>
            <div v-if="m.orderStatus == 5">订单状态 <span style="color:#ccc">已关闭</span> </div>
            <div v-if="m.orderStatus == 6 && !m.machineCode && !m.activationCode"><button @click="createdCDKEY(m,$event)">生成激活码</button></div>
        </div>
      </div> -->
      <pay ref="pay" :callback="payCallback"></pay>
      <cdkey ref="cdkey" :callback="payCallback"></cdkey>
  </div>
</template>
<style lang="scss">
@import "../assets/template/css/bootstrap.min.css";
@import "../assets/template/css/style.css";
@import "../assets/template/css/responsive.css";
@import "../assets/template/css/colors.css";
@import "../assets/template/css/animate.css";
#orderHistory{
  .horn{
    line-height:70px;
    height:70px;
    background:#fff url("../assets/img2/horn.png") no-repeat 10px center;
    padding-left:50px;
    color:#333;
  }
  .list{
    .order{
      border:1px solid;
      margin:5px 0;
      cursor: pointer;
    }
  }
  .box{
    margin-top:15px;
    .title{
      font-weight: bold;
      margin-bottom:8px;
    }
    .list{
      background:#fff;
      padding:15px;
    }
    .unpay{
      background:#fff;
      padding:15px;
      margin-bottom:8px;
      .unpay_title{
        display:flex;
        height: 30px;
        line-height: 30px;
        justify-content: center;
        align-items: center;
        &:before{
          content:" ";
          display:inline-block;
          width: 5px;
          height: 21px;
          background: #3FB8A4;
          vertical-align: middle;
        }
        .mealName{
          padding-left:15px;
          font-size: 22px;
          font-weight: 600;
          color: #3FB8A4;
        }
        .countdown{
          flex-grow:1;
          text-align: right;
          .time{
            color:#FD4646;
          }
        }
      }
      .unpay_body{
        padding:15px;
        .body_row{
          // display:flex;
          overflow:hidden;
          .body_col{
            width:50%;
            float:left;
            &.w100{width:100%;}
            padding:5px;
            &.module{
              .aModule{
                background:url("../assets/img2/contain.png") no-repeat left center;
                display:inline-block;
                line-height:24px;
                padding-left: 22px;
                background-size: 18px;
                margin-right:10px;
              }
            }
          }
        }
      }
      .unpan_footer{
        display:flex;
        justify-content: flex-end;
        align-items: center;
        .priceBox{
          .price{
            color:#3FB8A4;
            font-weight: bold;
          }
          margin-right:5%;
        }
        .cancel{
          color:#FD4646;
          cursor:pointer;
          margin-right:3%;
        }
      }
    }
  }
}
@media screen and (max-width: 600px){
    #orderHistory{
      .horn{
        margin-top:15px;
        line-height: 22px;
        padding-top: 8px;
        padding-bottom: 8px;
        height:unset;
      }
    }
}
</style>

<script>
import server from "@/public/service"
import {SUCCESS_CODE} from "@/public/state";
import getInterfaceData from "@/public/service/getInterfaceData";
import pay from "@/components/pay.vue";
import cdkey from "@/components/cdkey.vue";
import refreshStatus from "@/public/method/refreshStatus"
import moment from "moment";
import {toCurrentTime} from "@/public/method/timezone";

// RxJS v6+
import { interval } from 'rxjs';

// // 每1秒发出数字序列中的值
const source = interval(1000);
// // 数字: 0,1,2,3,4,5....
// const subscribe = source.subscribe(val => console.log(val));


export default {
  title: "Dingo Group",	
  data() {
    return {
        mealInfo:{},
        list:[],
        modules:[],
        unpayList:[],
        timezone:"",
        timezone2: Intl.DateTimeFormat().resolvedOptions().timeZone
    };
  },
  components:{
      pay,
      cdkey
  },
  methods: {
      readyPay(order,e){
        e.stopPropagation();
        this.$refs.pay.show(Object.assign({},{
          orderId: order.id
        },order));
      },
      getOrder(){
          var params = {
            userId: this.$store.state.userInfo.id,
            size:999,
            current:1,
          };
          server.getOrder(params).then(data=>{
              if(data.reCode === SUCCESS_CODE){
                  var result = getInterfaceData(data);
                  result.records.forEach(v=>{
                      v.activationTime = toCurrentTime(v.activationTime,this.timezone);
                      v.expireTime = toCurrentTime(v.expireTime,this.timezone);
                      v.paymentTime = toCurrentTime(v.paymentTime,this.timezone);
                      v.lastUpdateTime = toCurrentTime(v.lastUpdateTime,this.timezone);
                      v.functionName = toCurrentTime(v.functionName,this.timezone);
                      v.firstUpdateTime = toCurrentTime(v.firstUpdateTime,this.timezone);
                      v.consignTime = toCurrentTime(v.consignTime,this.timezone);
                  });
                  this.list = result.records.filter(v=>v.orderStatus != 1);
                  this.unpayList = result.records.filter(v=>v.orderStatus == 1).map(v=>{
                      var firstTime = moment(v.firstUpdateTime).format("x")*1; //创建订单时间
                      v.lastTime = firstTime + 1800000;
                      v.countTimeDesc = "30:00"; //倒计时
                      v.subscribe = source.subscribe(()=>{
                        var time = v.lastTime - (moment().format("x")*1);
                          // v.countTimeDesc = firstTime + ",";
                        if(time > 0){
                          v.countTimeDesc = moment(time).format("mm:ss");
                        }else{
                          v.countTimeDesc = "";
                          v.subscribe.complete();
                        };
                      })
                      try{
                          v.attributeData = JSON.parse(v.attribute || "{}");
                          v.funCodeArr = JSON.parse(v.funCode || "{}").fun_code.split(",");
                      }catch(e){
                          v.attributeData = {};
                          v.funCodeArr = [];
                      };
                      return v;
                  });
                  console.log("unpayList",this.unpayList)
              };
          });
      },
      cancelOrder(order,e){
        if(!order.countTimeDesc) return;
        e.stopPropagation();
        this.$confirm("确定取消该订单？").then(()=>{
            var params = {
              userId: this.$store.state.userInfo.id,
              orderId: order.id
            };
            server.cancelOrder(params).then(data=>{
                if(data.reCode === SUCCESS_CODE){
                    this.$message({
                        type:"success",
                        message:"取消成功",
                        showClose:true
                    })
                    this.getOrder();
                };
            });
        })
      },
      viewOrder(order){
        this.$store.state.orderDetail = JSON.parse(JSON.stringify(Object.assign({},{
          orderId: order.id
        },order)));
        this.$router.push("/orderDetail");
      },
      payCallback(){
        this.getOrder();
        refreshStatus();
      },
      createdCDKEY(order,e){
        e.stopPropagation();
        this.$refs.cdkey.show(order.id);
      },
      getAllModules(){
          server.getAllModules().then(data=>{
              if(data.reCode === SUCCESS_CODE){
                  var result = getInterfaceData(data);
                  this.modules = result;
              };
          });
      },
      viewMachineCode(meal){
        this.$refs.cdkey.viewMachineCode(meal.machineCode);
      },
      viewActivationCode(meal){
        this.$refs.cdkey.viewActivationCode(meal.activationCode);
      }
  },
  created(){
    this.getOrder();
    this.getAllModules();
    this.timezone = this.$store.state.userInfo.timezone;
  },
  destroyed(){
    this.unpayList.forEach(v=>{
      if(v.subscribe){
        v.subscribe.complete()
      }
    })
  }
};
</script>
